export default "__VITE_ASSET__BhZaFhvl__"